"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericInput = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const FormInput_1 = require("../text/FormInput");
// Hides the browser steppers on numeric inputs
const NumericInputWrapper = styled_1.default.div `
	input[type='number'] {
		-moz-appearance:textfield;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
`;
const NumericInput = (props) => {
    const { valid, handleChange } = props, passThru = __rest(props, ["valid", "handleChange"]);
    const onValueChangeHandler = (e) => {
        const inputNum = parseInt(e.target.value, 10);
        let propagateVal;
        if (e.target.value === '') {
            propagateVal = 0;
        }
        else {
            if (isNaN(inputNum)) {
                return;
            }
            propagateVal = inputNum;
        }
        if (handleChange) {
            handleChange(propagateVal);
        }
    };
    return React.createElement(NumericInputWrapper, null,
        React.createElement(FormInput_1.FormInput, Object.assign({ type: "text", pattern: "[0-9]*", onChange: onValueChangeHandler, noCharCount: true, valid: valid !== undefined ? valid : true }, passThru)));
};
exports.NumericInput = NumericInput;
//# sourceMappingURL=NumericInput.js.map